import React from 'react';
interface StatusIndicatorProps {
  status: 'online' | 'processing' | 'warning' | 'error';
  label?: string;
  pulse?: boolean;
}
export function StatusIndicator({
  status,
  label,
  pulse = true
}: StatusIndicatorProps) {
  const colors = {
    online: 'bg-tech-green',
    processing: 'bg-tech-blue',
    warning: 'bg-tech-yellow',
    error: 'bg-tech-red'
  };
  return <div className="inline-flex items-center gap-2" data-id="element-406">
      <div className="relative" data-id="element-407">
        <div className={`w-2 h-2 rounded-full ${colors[status]}`} data-id="element-408"></div>
        {pulse && <div className={`absolute inset-0 w-2 h-2 rounded-full ${colors[status]} animate-ping opacity-75`} data-id="element-409"></div>}
      </div>
      {label && <span className="text-xs font-mono text-dashboard-muted uppercase tracking-wider" data-id="element-410">
          {label}
        </span>}
    </div>;
}